<template>
  <b-container
    fluid
    :class="backgroundClass"
    class="px-0 StoryList"
  >
    <b-container class="pt-5">
      <b-row>
        <b-col
          cols="12"
          lg="7"
        >
          <h1
            :class="textClass"
            class="pb-5 StoryList__content"
          >
            {{ headline }}
          </h1>
        </b-col>
      </b-row>
      <b-row v-if="stories">
        <template v-for="story in stories">
          <b-col
            :key="story.index"
            cols="6"
            lg="4"
            md="6"
            :class="textClass"
          >
            <card
              :image="story.content.image"
              :content="story.name"
              :button-to="story.full_slug"
              button-title="Read"
              :button-variant="variant"
            />
          </b-col>
        </template>
      </b-row>
      <b-row>
        <b-pagination-nav
          v-model="page"
          :number-of-pages="totalPages"
          :base-url="`${$route.path}?page=`"
          last-number
        />
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
import Card from './Card.vue'

export default {
  name      : 'StoryList',
  components: { Card },
  props     : {
    headline: { type: String, default: '' },
    variant : {
      type   : String,
      default: '',
    },
    folderSlug: {
      type   : String,
      default: null,
    },
    storiesPerPage: {
      type   : String,
      default: '12',
    },
  },
  data () {
    return {
      stories   : null,
      totalPages: null,
    }
  },
  computed: {
    page () {
      return this.$route.query.page || 1
    },
    backgroundClass () {
      return `bg-${this.variant}`
    },
    textClass () {
      let className = ''
      switch (this.variant) {
        case 'primary':
          className = 'text-light'
          break
        case 'secondary':
          className = 'text-dark'
          break
        case 'light':
          className = 'text-dark'
          break
        case 'dark':
          className = 'text-light'
          break
      }
      return className
    },
  },
  created () {
    this.fetchStories()
  },
  methods: {
    async fetchStories () {
      const response  = await this.$storyblokHelper.fetchStoryList(this.folderSlug, this.page, this.storiesPerPage)
      this.stories    = response.stories
      this.totalPages = response.pages
    },

  },
}
</script>

<style lang="scss" scoped>
.StoryList {
  padding-bottom: 2em;
  @include media-breakpoint-up(lg) {
    padding-bottom: 3em;
  }
}
</style>
